import type { Channel } from '@getaccept/pusher';
import { EntityEvent } from '@getaccept/pusher';
import { onBeforeUnmount, onMounted } from 'vue';
import { until } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { pusherClientInternal } from '@getaccept/lib-shared/src/internal/pusher';
import { useEntityStore } from '../../entity/entity.store';
import { useLoadSubscription } from './load-subscription.composable';

export const useSubscriptionPusher = () => {
  const { pusherChannel } = storeToRefs(useEntityStore());
  const { loadSubscription } = useLoadSubscription();

  const onSubscriptionUpdated = () => {
    loadSubscription();
  };

  const init = async () => {
    await until(pusherChannel).toBeTruthy();
    pusherClientInternal.listen(
      pusherChannel.value as Channel,
      EntityEvent.SubscriptionUpdated,
      onSubscriptionUpdated
    );

    pusherClientInternal.listen(
      pusherChannel.value as Channel,
      EntityEvent.UserProfileCreated,
      onSubscriptionUpdated
    );

    pusherClientInternal.listen(
      pusherChannel.value as Channel,
      EntityEvent.UserProfileUpdated,
      onSubscriptionUpdated
    );

    pusherClientInternal.listen(
      pusherChannel.value as Channel,
      EntityEvent.UserProfileDeleted,
      onSubscriptionUpdated
    );
  };

  onMounted(init);

  onBeforeUnmount(() => {
    if (!pusherClientInternal) return;

    pusherClientInternal.unbind(
      pusherChannel.value as Channel,
      EntityEvent.SubscriptionUpdated,
      onSubscriptionUpdated
    );

    pusherClientInternal.unbind(
      pusherChannel.value as Channel,
      EntityEvent.UserProfileCreated,
      onSubscriptionUpdated
    );

    pusherClientInternal.unbind(
      pusherChannel.value as Channel,
      EntityEvent.UserProfileUpdated,
      onSubscriptionUpdated
    );

    pusherClientInternal.unbind(
      pusherChannel.value as Channel,
      EntityEvent.UserProfileDeleted,
      onSubscriptionUpdated
    );
  });
};
